/* eslint-disable react/react-in-jsx-scope */
import {
  Box,
  Container,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { List } from "reactstrap";

function SecondSectionHome() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");

      const element = document.getElementById(id);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100); // small delay fixes timing issues
      }
    }
  }, [hash]);

  return (
    <Box
      component="section"
      id="why-memorialgo"
      className="second-section"
      sx={{
        py: { xs: 4, md: 6 },
        backgroundColor: "#fff",
        color: "#104145 !important",
      }}
    >
      <Container maxWidth="xl">
        <Typography
          variant="h4"
          component="h2"
          sx={{
            textAlign: "center",
            marginBottom: "2rem",
            fontWeight: 600,
            fontSize: { xs: "24px", md: "32px", lg: "34px" },
            lineHeight: { xs: "28px", md: "36px", lg: "40px" },
            color: "#104145",
          }}
        >
          Who <span style={{ color: "#9F7F2C" }}>We are</span>
        </Typography>

        <Container
          sx={{
            display: { xs: "block", md: "flex" },
            justifyContent: "center",
            alignItems: "center",
            flexDirection: { xs: "column", md: "row" },
            maxWidth: { md: "1250px" },
            gap: { md: "2rem" },
          }}
        >
          <Box
            sx={{
              marginBottom: { xs: 2, md: 0 },
              width: { md: "40%" },
            }}
          >
            <Typography
              sx={{
                color: "#104145 !important",
                fontWeight: "400 !important",
                fontStyle: "normal !important",
                fontSize: "59px !important",
                lineHeight: "100% !important",
                letterSpacing: "0% !important",
                width: { md: "100%" },
                textAlign: { xs: "start", md: "start" },
              }}
            >
              A <span style={{ color: "#9F7F2C" }}>Gentle</span>,<br />
              Guided Way to Plan Farewells
            </Typography>
          </Box>

          <Box
            component="section"
            className="second-section"
            sx={{
              backgroundColor: "#fff",
              color: "#104145 !important",
              width: { md: "38%" },
            }}
          >
            <Typography align="left" sx={{ color: "#104145 !important" }}>
              Planning funeral and memorial services is a deeply personal
              journey.{" "}
              <Box
                color={"#104145"}
                component="span"
                sx={{
                  fontWeight: "bold",
                }}
              >
                MemorialGo{" "}
              </Box>
              offers guidance to help you explore options, connect with local
              providers, and make informed choices that feel right for you and
              your family.
            </Typography>
            <Typography
              align="left"
              sx={{
                color: "#104145 !important",
                mt: 2,
                fontWeight: "bold !important",
              }}
            >
              MemorialGo brings clarity by helping you:
            </Typography>

            <List
              align="left"
              sx={{ listStyleType: "disc", color: "#104145 !important" }}
            >
              <ListItem sx={{ display: "list-item", py: 0 }}>
                <ListItemText primary="Understand your options and next steps" />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0 }}>
                <ListItemText primary="Connect with trusted local providers" />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0 }}>
                <ListItemText primary="Make decisions aligned with personal wishes and priorities" />
              </ListItem>
            </List>

            <Typography
              variant="body1"
              align="left"
              sx={{
                color: "#104145 !important",
                marginTop: "1rem !important",
              }}
            >
              No{" "}
              <Box
                color={"#104145"}
                component="span"
                sx={{
                  fontWeight: "bold",
                }}
              >
                complex
              </Box>{" "}
              searches. No{" "}
              <Box
                color={"#104145"}
                component="span"
                sx={{
                  fontWeight: "bold",
                }}
              >
                starting over
              </Box>{" "}
              at every step. Simply{" "}
              <Box
                color={"#104145"}
                component="span"
                sx={{
                  fontWeight: "bold",
                }}
              >
                thoughtful guidance,
              </Box>{" "}
              designed to bring clarity and direction.
            </Typography>
          </Box>
        </Container>
      </Container>
    </Box>
  );
}

export default SecondSectionHome;
